import { isValidCron } from 'cron-validator';
import * as yup from 'yup';

yup.addMethod(yup.string, 'json', function (message = 'Must be valid json') {
  return this.test('is-json', message, function (value) {
    if (!value) {
      return true;
    }
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  });
});

yup.addMethod(
  yup.string,
  'validateJsonProp',
  function (propertyPath, validatorFunc) {
    return this.test(
      'validate-json-prop',
      `Invalid value for property ${propertyPath}`,
      function (value) {
        if (!value) {
          return true;
        }

        try {
          const parsedJson = JSON.parse(value);

          // Navigate to the specified property using the path
          const pathParts = propertyPath.split('.');
          let objProp = parsedJson;

          for (const part of pathParts) {
            if (
              objProp === undefined ||
              objProp === null ||
              typeof objProp !== 'object'
            ) {
              return false;
            }

            objProp = objProp[part];
          }

          return validatorFunc(objProp);
        } catch {
          return false;
        }
      }
    );
  }
);

yup.addMethod(
  yup.string,
  'cron',
  function (message = 'Must be valid cron string') {
    return this.test('is-cron', message, function (value) {
      if (!value) {
        return true;
      }

      return isValidCron(value, {
        alias: true,
        seconds: false,
        allowBlankDay: false,
        allowSevenAsSunday: false,
      });
    });
  }
);
